import $ from "jquery"

function showActiveCampaignNewsletterForm(){
    const activeCampaignNewsletter = $('.js-activecampaign-newsletter-form');
    const bodyMain = $('body');

    activeCampaignNewsletter.addClass('d-flex');
    activeCampaignNewsletter.removeClass('d-none');
    bodyMain.addClass('o-hidden');
}

function hideActiveCampaignNewsletterForm(){
    const activeCampaignNewsletter = $('.js-activecampaign-newsletter-form');
    const bodyMain = $('body');

    activeCampaignNewsletter.removeClass('d-flex');
    activeCampaignNewsletter.addClass('d-none');
    bodyMain.removeClass('o-hidden');
}

const activeCampaignSubmit = $('.js-active-campaign-submit');
const activeCampaignConsent = $('.js-active-campaign-consent');
const activeCampaignInputCheckbox = $("._checkbox-radio input[type='checkbox']");

$('.js-activecampaign-newsletter').on('click', function(e){
    e.preventDefault();

    showActiveCampaignNewsletterForm();
});

$('.js-activecampaign-newsletter-close').on('click', function(e){
    hideActiveCampaignNewsletterForm();
});

// Check when user toggle "All" input checkbox, it will checked all the input checkbox
activeCampaignInputCheckbox.on('change', function(){
    if($(this).hasClass('any')){
        if(this.checked){
            activeCampaignInputCheckbox.each(function(){
                this.checked=true;
            });
        }else{
            activeCampaignInputCheckbox.each(function(){
                this.checked=false;
            });
        }
    }
});

// Check when user toggle other input checkbox it will toggle off "All" input checkbox
activeCampaignInputCheckbox.on('click', function () {
    if(!$(this).hasClass('any')){
        if ($(this).is(":checked")){
            var isAllChecked = 0;

            activeCampaignInputCheckbox.each(function(){
                if(!this.checked){
                    isAllChecked = 1;
                }
            });
                            
            if(isAllChecked == 0){ 
                $("input[type=checkbox].any").prop("checked", true); 
            }     
        }else {
            $("input[type=checkbox].any").prop("checked", false);
        }
    }
});

// Validate value for the consent checkbox
activeCampaignConsent.on('change', function(){
    let activeCampaignForm = activeCampaignConsent.closest('.activecampaign-newsletter__main');
    let activeCampaignFormInput = activeCampaignForm.find('form').find('.custom-acceptance input[type="checkbox"]');
    activeCampaignFormInput.trigger('click');
    if($(this).is(':checked')){
        activeCampaignSubmit.prop("disabled", false);
        activeCampaignFormInput.prop("checked", true);
    }else{
        activeCampaignSubmit.prop("disabled", true);
        activeCampaignFormInput.prop("checked", false);
    }
});

// Validate value for options checkbox input type
$('._checkbox-radio input[type=checkbox]').each(function(){
    $(this).on('change', function(){
        const checkedOptions = $('._checkbox-radio input[type=checkbox]:checked');

        if (!checkedOptions.length) {
            $('._form-content').addClass('checkbox-error');
        }else{
            $('._form-content').removeClass('checkbox-error');
        }
    });
});

// Validate email address value
function validateEmail(email) {
    var emailRegEx = /\S+@\S+\.\S+/;
    return emailRegEx.test(email);
}

const emailValueInput = $('#email').val();

$('#email').on('keyup paste', function(){
    if (emailValueInput == '' && !validateEmail($(this).val())) {
        $(this).addClass('_has_error');
    }else{
        $(this).removeClass('_has_error');
    }
});

// When user clicks submit button
activeCampaignSubmit.on('click', function(){
    const checkedOptions = $('._checkbox-radio input[type=checkbox]:checked');
    const emailValue = $('#email').val();

    // Validate value for options checkbox input type
    if (!checkedOptions.length) {
        $('._form-content').addClass('checkbox-error');
    }else{
        $('._form-content').removeClass('checkbox-error');
    }

    // Validate email address value
    if (emailValue == '' || !validateEmail($('#email').val())) {
        $('#email').addClass('_has_error'); 
    }else{
        $('#email').removeClass('_has_error');
    }

    if ( checkedOptions.length && (emailValue != '' && validateEmail($('#email').val())) ) {
        let activeCampaignForm = activeCampaignConsent.closest('.activecampaign-newsletter__main');
        let activeCampaignFormSubmit = activeCampaignForm.find('form').find('input[type="submit"]');

        activeCampaignFormSubmit.trigger('click').on('submit');
        $('.js-active-campaign-submit').prop('disabled', true);
        $('.activecampaign-newsletter__inner').addClass('activecampaign-newsletter__inner--progress');
        // $(document).on('wpcf7mailsent', function () {
        //     $('.activecampaign-newsletter__inner').removeClass('activecampaign-newsletter__inner--progress');
        //     $('.activecampaign-newsletter__main').addClass('d-none');
        //     $('.activecampaign-newsletter__inner').addClass('activecampaign-newsletter__inner--thankyou');
        //     $('.activecampaign-newsletter__box--returning').removeClass('d-none');
        //     $('.activecampaign-newsletter__box--returning').addClass('d-flex');
        //     $('.activecampaign-newsletter__banner').removeClass('d-lg-flex');
        //     $('.js-contact-thankyou, .js-contact-thankyou-overlay').hide();
        // });

        document.querySelector('.activecampaign-newsletter form').addEventListener('wpcf7mailsent', function(event) {
            console.log('wpcf7mailsent');
            const apiResponse = event.detail.apiResponse;
            $('.activecampaign-newsletter__inner').removeClass('activecampaign-newsletter__inner--progress');
            $('.activecampaign-newsletter__main').addClass('d-none');
            $('.activecampaign-newsletter__inner').addClass('activecampaign-newsletter__inner--thankyou');
            $('.activecampaign-newsletter__banner').removeClass('d-lg-flex');
            $('.js-contact-thankyou, .js-contact-thankyou-overlay').hide();

            if (apiResponse && apiResponse.gr_status == 'resubbed') {
                $('.activecampaign-newsletter__box--returning').removeClass('d-none').addClass('d-flex');
            } else {
                $('.activecampaign-newsletter__box--confirmation').removeClass('d-none').addClass('d-flex');
            }
          }, false);
    }
});

// When user press esc key
$(document).on('keyup', function(e) {
    if (e.key == "Escape") { 
        hideActiveCampaignNewsletterForm();
    }
});

// When user clicks on the active campaign overlay section or outside the form
$(document).on('mouseup', function(e) {
    var container = $('.activecampaign-newsletter__inner');

    if (!container.is(e.target) && container.has(e.target).length === 0){
        hideActiveCampaignNewsletterForm();
    }
});